module.exports = client =>
  client.app && typeof client.app.releaseStage === 'string'
    ? client.app.releaseStage
    : client.config.releaseStage



// WEBPACK FOOTER //
// base/lib/infer-release-stage.js